import { Component, EventEmitter, Input, OnInit, OnChanges, Output, SimpleChanges } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MerchantToolType } from 'OpsCenter/merchant-tools/models/merchant-tool-type';
import { MigrationToolService } from 'OpsCenter/merchant-tools/migration-form/services/migration-tool.service';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs/Subject';
import { IntegrationPartnerRequest } from 'OpsCenter/merchant-tools/models/integration-partner-request';
import { IntegrationPartnerSource } from 'OpsCenter/merchant-tools/models/integrationPartnerSource';
import { MigrationStatusType } from 'OpsCenter/merchants/settings/migration-status-type';

@Component({
  selector: 'app-integration-migration-form',
  template: require('./integration-migration-form.component.html'),
  styles: [require('./integration-migration-form.component.scss')],
})
export class IntegrationMigrationFormComponent implements OnInit, OnChanges {
  @Input() merchant: any;
  @Input() requestedSuccessfully;
  @Input() integrationPartnerSources: any;
  @Input() currentIntegrationMigrationStatus: MigrationStatusType;
  @Input() errorMessage: string;
  @Input() mozrestId: string;
  @Input() integrationPartnerSubSources: any;

  @Output() onFormSubmit = new EventEmitter<IntegrationPartnerRequest>();
  @Output() errorOccurred = new EventEmitter<string>();

  public shouldShowSubSources = false;
  public form: FormGroup;
  private destroy$ = new Subject();

  constructor(private formBuilder: FormBuilder, private migrationToolService: MigrationToolService) {}

  ngOnInit(): void {
    function findIdBySsoClientId(arr, targetSsoClientId) {
      const obj = arr.find(item => item.ssoClientId === targetSsoClientId);
      return obj ? obj.id : null;
    }
    this.migrationToolService
      .getExternalPartnerSources()
      .pipe(takeUntil(this.destroy$))
      .subscribe(response => {
        this.integrationPartnerSources = response.sources;
        this.integrationPartnerSubSources = response.subSources;
        this.mozrestId = findIdBySsoClientId(this.integrationPartnerSources, 'mozrest');
      });
    this.form = this.buildForm();

    this.form.get('selectedIntegrationPartnerSource').valueChanges.subscribe(val => {
      this.shouldShowSubSources = val === this.mozrestId && !this.currentIntegrationMigrationStatus;
      const subSourceControl = this.form.get('selectedIntegrationPartnerSubSource');
      if (this.shouldShowSubSources) {
        subSourceControl.setValidators([Validators.required]);
      } else {
        subSourceControl.clearValidators();
        subSourceControl.setValue('', { emitEvent: false });
      }
      subSourceControl.updateValueAndValidity();
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.currentIntegrationMigrationStatus) {
      if (this.currentIntegrationMigrationStatus && this.form && this.form.get('selectedIntegrationPartnerSubSource')) {
        this.shouldShowSubSources = false;
        this.form.get('selectedIntegrationPartnerSubSource').setValue('', { emitEvent: false });
      }
    }
  }

  private initForm(): void {
    this.form = this.formBuilder.group({
      selectedIntegrationPartnerSource: ['', [Validators.required]],
      externalId: ['', [Validators.required]],
      selectedIntegrationPartnerSubSource: ''
    });
  }

  public onSubmitClick() {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      this.errorOccurred.emit('You have invalid fields in the form. Please fix them and try again');
    } else {
      if (window.confirm(`This is a one-way operation and cannot be undone.`)) {
        this.onFormSubmit.emit({
          selectedIntegrationPartnerSource: this.form.controls.selectedIntegrationPartnerSource.value,
          externalId: this.form.controls.externalId.value,
          subSource: this.form.controls.selectedIntegrationPartnerSubSource.value,
        });
      }
    }
  }

  private buildForm(): any {
    return this.formBuilder.group({
      selectedIntegrationPartnerSource: ['', [Validators.required]],
      externalId: ['', [Validators.required]],
      selectedIntegrationPartnerSubSource: ''
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/merchant-tools/integration-migration-form/integration-migration-form.component.ts